'use client'

import { useEffect, useRef } from 'react'
import { CmsBlogItem } from '../../../../domain/cmsBlogList'

type AnimationEventOnBlogListProps = {
  items: CmsBlogItem[]
  classNameItem: string
}

const AnimationEventOnBlogList = ({ items, classNameItem }: AnimationEventOnBlogListProps) => {
  const intersectionObserverRef = useRef<IntersectionObserver>()

  useEffect(() => {
    if (!intersectionObserverRef.current) {
      intersectionObserverRef.current = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return
            }

            entry.target.classList.remove(classNameItem)
            observer.unobserve(entry.target)
          })
        },
        { threshold: 0.3 },
      )
    }

    document.querySelectorAll(`.Blog-list-container .Blog-item.${classNameItem}`).forEach((el) => {
      intersectionObserverRef.current?.observe(el)
    })

    return () => intersectionObserverRef.current?.disconnect()
  }, [items.length])

  return null
}

export default AnimationEventOnBlogList
